<template>
  <div class="app-container">
    <div class="bg-white ">
      <div class="flex justify-center w-11/12 mx-auto md:justify-between sm:h-16">
        <a href="https://www.cruzverde.cl">
          <img
            src="@/assets/images/logo-cv.png"
            alt=""
            class="w-20 sm:20 md:w-24 lg:w-24 absolute"
          >
        </a>
        <a
          href="https://www.cruzverde.cl"
          class="text-cv-green text-lg mt-4"
        >
          <font-awesome-icon
            icon="chevron-left"
            class="mr-1"
          />
          Volver
        </a>
      </div>
    </div>

    <div class="content">
      <div class="grid grid-row-7 grid-flow-col">
        <div class=" col-span-4 sm:col-span-1 bg-black p-6">
          <img
            src="@/assets/images/img@2x.png"
            alt=""
            class="mx-4 mx-auto hidden sm:block w-2/5"
          >
          <img
            src="@/assets/images/img.png"
            alt=""
            class="mb-8 mx-auto -mb-1 sm:hidden"
          >
        </div>
        <div class=" col-span-3 sm: col-span-6 bg-cv-green text-left p-4  ">
          <h2 class="text-white text-xl md:text-3xl mt-10 sm:mt-24 font-bold">
            Verificación de enrolamiento
          </h2>
        </div>
      </div>
      <section class="container flex  flex-col sm:flex-row md:flex-row lg:flex-row ">
        <div class="box-s flex-1 mx-1 my-4 sm:mx-4">
          <div class="text-center mx-2 text-cv-gray text-sm sm:text-base ">
            <p class="text-center mx-1 p-2">
              Exclusivo para beneficiarios del Sistema de Salud del Ejército de Chile (SISAE)
              y personal que trabaja en la institución.
            </p>
            <div
              class="justify-center sm:justify-start md:w-full mt-6   md:text-center"
            >
              <label class="w-full md:w-2/6 md:p-4 mb-2 ">
                RUN
              </label>
              <br class="sm:hidden">
              <input
                v-model="rut"
                v-rut:live
                class="w-full rut py-3 px-4 m-3 "
                type="text"
                maxlength="12"
              >
              <br>
              <span class="text-gray-500">(Sin puntos ni guion)</span>
            </div>
            <div class="w-full md:w-12/12 px-3 mb-6  mt-2 md:mb-0">
              <button
                class="btn p-4 ml-4 md:mt-0"
                @click="handleSearch"
              >
                VALIDAR
              </button>
              <br>
              <div
                v-if="error"
                class="error-message"
              >
                NO ENROLADO
              </div>
            </div>
          </div>
        </div>
        <div
          class="box-s flex-1 mx-1 my-4 sm:mx-4"
        >
          <div class="block sm:hidden">
            SOLICITUD DE ENROLAMIENTO
            <font-awesome-icon
              :icon=" solicitud ? 'caret-up':'caret-down' "
              class=" float-right"
              @click="toggle"
            />
          </div>
          <div v-if="solicitud">
            <div class="text-center mx-2 text-cv-gray text-sm sm:text-base ">
              <p class="text-center mx-1 p-2">
                Si no estás enrolado. Ingresa tus datos y te informaremos
                del nuevo calendario de enrolamiento.
              </p>
              <div
                class="sm:flex sm:justify-center md:w-full mt-6 md:text-center"
              >
                <label class="w-full md:w-1/6 p-4 pt-6 text-left pl-6 mb-2 ">
                  E-MAIL
                </label>
                <input
                  v-model="subscriber.email"
                  class="w-full md:w-5/6 rut py-3 px-4 m-3 "
                  type="email"
                >
                <br>
              </div>
              <div
                class="sm:flex sm:justify-center md:w-full mt-6"
              >
                <label class="w-full md:w-1/6 p-4 pt-6 mb-2 pl-6 text-left ">
                  RUN
                </label>
                <input
                  v-model="subscriber.rut"
                  v-rut:live
                  class="w-full md:w-5/6 rut py-3 px-4 m-3 "
                  type="text"
                  maxlength="12"
                >
                <br>
              </div>
              <div class="w-full md:w-12/12 px-3 mb-6  mt-2 md:mb-0">
                <button
                  class="btn p-4 ml-4 md:mt-0"
                  @click="handleEnrolamiento"
                >
                  ENVIAR
                </button>
                <br>
                <span class="text-gray-500">
                  *Datos obligatorios para recibir información de la actividad
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer class="footer" />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import DataService from './services/DataService';

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loading: false,
      error: false,
      rut: '',
      subscriber: {
        email: '',
        rut: '',
      },
      solicitud: true,
    };
  },
  created() {
    this.solicitud = !this.isMobile();
  },
  methods: {
    async handleSearch() {
      if (!this.rut) return;

      this.error = false;
      this.loading = true;
      DataService.getByRut(this.rut)
        .then((response) => {
          if (response.data.message === 'ENROLADO') {
            this.showModal('success', 'ENROLADO');
          } else {
            this.showModal('error', 'NO ENROLADO', true);
          }
          this.rut = '';
        })
        .catch(() => {
          this.showModal('error', 'NO ENROLADO', true);
        });
    },

    async handleEnrolamiento() {
      if (!this.subscriber.rut || !this.subscriber.email) return;

      this.error = false;
      this.loading = true;
      DataService.enrolar(this.subscriber)
        .then(() => {
          this.showModal('success', 'SOLICITUD ENVIADA');
          this.cleanSubs();
        })
        .catch(() => {
          this.showModal('error', 'RUT YA REGISTRADO');
        });
    },

    showModal(status, msg, error = false) {
      this.$fire({
        title: `<span class="text-cv-labelGreen text-base">${msg}</span>`,
        type: status,
        showConfirmButton: false,
        timer: 2000,
      });
      this.error = error;
      this.solicitud = true;
    },

    cleanSubs() {
      this.subscriber.rut = '';
      this.subscriber.email = '';
    },

    toggle() {
      this.solicitud = !this.solicitud;
    },

    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @apply   w-11/12 mx-auto px-0 font-roboto;

  @screen sm {
    @apply py-8 px-24;
  }
}

.error-message {
  color: white;
  background: red;
  width: 80%;
  padding: 0.3rem;
  margin: 1em auto;
}

.rut {
  max-width: 15em;
}

.app-container {
  @apply flex flex-col h-full;
  .header {
    @apply flex-shrink-0;
  }
  .content {
    @apply flex-1;
  }
  .footer {
    @apply flex-shrink-0;
  }
}
</style>
